/** First and last initials of a full name, e.g. "Jane van Doe" -> "JD". */
export function profileInitials(fullName: string | null | undefined): string {
  const parts = (fullName ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

/**
 * "EMPLOYEES MANAGEMENT" -> "Employees management". Text that is not entirely in capitals
 * ("BSA Org", "Contract Ending") or has no letter case (Arabic) is returned unchanged.
 */
export function sentenceCaseIfShouting(text: string | null | undefined): string {
  const value = text ?? '';
  if (value !== value.toLocaleUpperCase() || value === value.toLocaleLowerCase()) return value;
  return value.charAt(0) + value.slice(1).toLocaleLowerCase();
}
